import { useTranslation } from 'react-i18next';
import { TooltipRenderProps } from 'react-joyride';

import { Typography } from '@/shared/components/atoms/Typography';

import Close from '~/images/shared/Close.svg';

function TourTooltip(props: TooltipRenderProps) {
  const { t } = useTranslation();

  const { closeProps, index, primaryProps, step, size, tooltipProps } = props;

  return (
    <div
      className='flex max-w-xs flex-col gap-4 rounded-lg bg-primary-new-10 p-12'
      {...tooltipProps}
    >
      <div className='flex items-center justify-between text-background-neutral-100'>
        <Typography variant='caption'>
          {t('step-counter', { step: index + 1, totalSteps: size })}
        </Typography>
        <span {...closeProps}>
          <Close width='13' height='13' />
        </span>
      </div>
      <Typography
        weight='semiBold'
        variant='caption'
        className='text-background-neutral-100'
      >
        {t(step.title as string)}
      </Typography>
      <Typography variant='caption' className='text-surface-variant'>
        {t(step.content as string)}
      </Typography>
      <Typography
        weight='semiBold'
        variant='caption'
        className='text-background-neutral-100 underline'
        {...primaryProps}
      >
        {t(index < 4 ? 'next' : 'get-started')}
      </Typography>
    </div>
  );
}

export default TourTooltip;
